require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./venir-lepfl-2-5-1.json") })
        }
      }, "path---venir-lepfl-2-5-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---venir-lepfl-2-5-1!./.cache/json/venir-lepfl-2-5-1.json
// module id = 599
// module chunks = 231608221292675